
export type UploadLectureResourceBody = {
  /** 업로드할 파일 */
  file: Blob;
  /** 자료 제목 (선택사항) */
  title?: string;
};
